import './lazyLoading.less';

import { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';

import PageContainer, { PageLevel } from '@/components/PageContainer';
import Spin from '@/components/Spin';

import * as components from './components';
import firstLevelRoutesList from './FirstLevelRoutes';
import subPageRoutes from './subPageRoutes';

interface IRoute {
  path: string;
  element?: string;
  redirect?: string;
  replace?: boolean;
  layout?: React.ReactNode;
  lazy?: boolean;
  pageWrapperClass?: string;
}

const routes: (IRoute & { level: PageLevel })[] = [];
routes.push(
  ...firstLevelRoutesList.map((route: IRoute) => ({
    ...route,
    level: PageLevel.main,
  })),
);
routes.push(
  ...subPageRoutes.map((route: IRoute) => ({
    ...route,
    level: PageLevel.sub,
  })),
);

export default routes.map(
  ({ path, element, lazy, level, redirect, replace, pageWrapperClass }) => {
    if (redirect) {
      return (
        <Route
          key={path}
          path={path}
          element={<Navigate to={redirect} replace={replace} />}
        />
      );
    }

    if (!element) {
      return (
        <Route key={path} path={path} element={<Navigate to="/" replace />} />
      );
    }

    const Component = components[element as keyof typeof components];

    if (!Component) {
      return (
        <Route key={path} path={path} element={<Navigate to="/" replace />} />
      );
    }

    return (
      <Route
        key={path}
        path={path}
        element={
          <PageContainer pageLevel={level} pageWrapperClass={pageWrapperClass}>
            {lazy ? (
              <Suspense
                fallback={
                  <Spin wrapperClassName="by-us-lazy-loading">
                    <div></div>
                  </Spin>
                }
              >
                <Component />
              </Suspense>
            ) : (
              <Component />
            )}
          </PageContainer>
        }
      />
    );
  },
);
